import React from 'react'
import { SETTINGS_KEYS, environment } from '../../config/environment'
import { useSetting } from '../../hooks/useSettings'
import './Logo.scss'

interface LogoProps {
  height?: string
  className?: string
  iconOnly?: boolean
}

const Logo: React.FC<LogoProps> = ({ height = '6em', className = '', iconOnly = false }) => {
  const customLogoPath = useSetting(SETTINGS_KEYS.APP_LOGO)

  const customLogo = customLogoPath?.length ? environment.apiBaseUrl.replace(/\/api\/$/, customLogoPath) : null

  const logoSrc = customLogo || (iconOnly ? environment.appLogoIcon : environment.appLogo)

  if (logoSrc) {
    return (
      <img
        src={logoSrc}
        className={`logo ${className}`}
        style={{ height }}
        alt="Logo"
        draggable={false}
        onDragStart={(e) => e.preventDefault()}
      />
    )
  }

  return null
}

export default Logo
export { Logo }
